<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter">
<p class="chapterTitle"><a href="#/toc01#chap_04" id="chap04">IS IT OK TO EAT A WORM?</a></p>
<p class="chapterAuthor">Bear Grylls</p>
<p class="subhead">explorer and survival expert</p>
<p class="paraNoIndent">Well, here’s the thing … If your life depends on it, then you bet it is OK to eat a worm. But you don’t want to be doing it every day, trust me. And if you do eat one, you’ve got to be careful because worms can have some bad stuff in their tums (as they wiggle around all day underground!) So it’s best to cook them up. I find if you boil them up with some pine needles over a fire, it makes them taste a little bit better.</p>
<p class="para">I will never forget the first worm I ate. I was standing there, incredulous, watching this soldier suck a long, juicy worm up between his teeth and munch it down raw. I was almost sick. When it was my turn, I think I nearly <em class="italic">was</em> sick.</p>
<p class="para">But guess what? If you do it enough and you are hungry enough, then it gets easier. And there is the real secret of life and survival: if your spirit is strong enough, you will find a way to do the impossible. That’s the lesson of the worm. Oh, and remember: keep smiling even when it’s raining. That’s the second-most important lesson. So get out there and explore!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap04.vue?060fdf14